import { Sector, SectorValues } from '@/domain/impact/impact.entity';
import {
  BuildingHeatingType,
  BuildingHeatingValues,
  ImpactCo2Answer,
  Source,
  SourceValues,
  ValuesBuildingHeating,
} from '@/domain/impact-co2/entities/question.entity';
import { validateValueInType } from '@/domain/utils/validate-value-in-type';

import { QuestionBuildingHeatingDto } from './dto.type';

export class QuestionBuildingHeatingMapper {
  static dtoToEntity(
    dto: QuestionBuildingHeatingDto,
  ): ImpactCo2Answer<ValuesBuildingHeating> {
    return {
      id: dto.id,
      userId: dto.userId,
      sector: validateValueInType<Sector>(dto.sector, SectorValues),
      category: 'BUILDING_HEATING',
      isExternal: dto.isExternal,
      source: validateValueInType<Source>(dto.source || '', SourceValues),
      values: {
        buildingHeatingType: validateValueInType<BuildingHeatingType>(
          dto.buildingHeatingType,
          BuildingHeatingValues,
        ),
        buildingSize: Number.parseFloat(dto.buildingSize.toString()),
        numberOfMonthsOfUse: Number.parseFloat(
          dto.numberOfMonthsOfUse.toString(),
        ),
        label: dto.label || '',
        score: dto.score || 0,
        tags:
          dto?.tags?.values?.map((tag) => ({ id: tag.id, name: tag.name })) ||
          [],
      },
    };
  }

  static entityToDto(
    answer: ImpactCo2Answer<ValuesBuildingHeating>,
    projectId: number,
  ): Omit<
    QuestionBuildingHeatingDto,
    'id' | 'userId' | 'score' | 'isExternal'
  > {
    return {
      projectId: projectId,
      sector: answer.sector,
      buildingHeatingType: answer.values.buildingHeatingType,
      buildingSize: answer.values.buildingSize,
      numberOfMonthsOfUse: answer.values.numberOfMonthsOfUse,
      label: answer.values.label || '',
      source: answer.source !== '' ? answer.source : undefined,
      tags: { values: answer.values.tags },
    };
  }
}
